import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getTierDeviationsStreamId } from '../helpers';
import { fetchMoreTierDeviations } from '../actions';
import { getCurrentTierId, getCurrentMediaSource } from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
import { PapiDeviation } from '@wix/da-papi-types';

export type WithTierDeviationsProps = {
  deviations: PapiDeviation[];
  hasMore: boolean;
  isFetching: boolean;
  isInitialized: boolean;
  fetchMoreTierDeviations: () => any;
};

const mapStateToProps = state => {
  const mediaSourceType = getCurrentMediaSource(state);
  const currentTierId = getCurrentTierId(state);
  const streamId = getTierDeviationsStreamId(mediaSourceType, currentTierId);
  return {
    deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
    hasMore: selectors.hasMore(state, streamId),
    isInitialized: selectors.isInitialized(state, streamId),
    isFetching: selectors.isFetching(state, streamId),
  };
};

export const useCurrentTierDeviations = (): WithTierDeviationsProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
  ...useMMDispatchActions({
    fetchMoreTierDeviations,
  }),
});

export default connectMediaStore(mapStateToProps, {
  fetchMoreTierDeviations,
});
